import { createSelector } from 'reselect';

import parseArrayToObject from 'src/universal/utils/parseArrayToObject';

import { getVacPageData } from 'page_modules/business-vac/redux/mainPageData';
import { getCardColorInfoList } from 'src/universal/redux/cardColors';
import { getPznOfferList } from 'src/universal/redux/pznData';
import { isG186Variant } from 'src/universal/components/Experiments/G186/redux';

export const getAnnualFeeLabel = createSelector([getVacPageData], ({ labels }) =>
  labels.find(label => label.identifier === 'annualFee')
);

export const getLabels = createSelector(
  [getVacPageData],
  ({ mobileTilesExtended }) => {
    return parseArrayToObject(mobileTilesExtended?.labels ?? [], 'identifier');
  }
);

export const getDtm = createSelector([getVacPageData], ({ mobileTilesExtended }) => {
  return parseArrayToObject(mobileTilesExtended?.listTileDTM ?? [], 'key');
});

export const makeGetPznOffer = () =>
  createSelector(
    [getPznOfferList, isG186Variant, (_, shortName) => shortName],
    (offerList, isG186, shortName) => {
      if (isG186 && shortName === 'gold') {
        const offerGold = offerList?.find(offer => offer.shortName === shortName);
        if (offerGold?.ahaWelcomeOffer?.header) {
          return {
            ...offerGold,
            header: offerGold.ahaWelcomeOffer.header
          };
        }
        return offerGold;
      }
      return offerList?.find(offer => offer.shortName === shortName);
    }
  );

export const makeGetAnnualFeeDisclaimer = () =>
  createSelector(
    [getCardColorInfoList, (_, shortName) => shortName],
    (colorInfoList, shortName) => {
      const colorInfo = colorInfoList.find(c => c.shortName === shortName);
      return colorInfo?.rubiksContent?.annualFeeDisclaimer;
    }
  );

export const makeGetFeaturedBenefits = () =>
  createSelector(
    [getVacPageData, (_, shortName) => shortName],
    ({ horizontalCardTiles }, shortName) => {
      const { cards } = horizontalCardTiles ?? [];
      const cardsByShortName = parseArrayToObject(cards, 'shortName');
      const cardData = cardsByShortName[shortName];
      return cardData?.featuredBenefits ?? [];
    }
  );

export const makeGetCardEep = () =>
  createSelector(
    [getPznOfferList, (_, shortName) => shortName],
    (offerList, shortName) => {
      const offer = offerList?.find(offer => offer.shortName === shortName);
      return offer?.eep;
    }
  );
